import {
  DetailAttCkList,
  getAttackTypeList,
  getDetailAttCkList,
  getFailPluginLog,
  GetResultInfo,
  getResultInfo,
  ResultDefenseRankings,
  resultDefenseRankings,
  resultDetail,
  ResultDetail,
  ResultProgressDetail,
  resultProgressDetail,
  ResultProgressList,
  resultProgressList,
  ResultResourceDetail,
  resultResourceDetail,
  ResultResourceEmailDetail,
  resultResourceEmailDetail,
  ResultResourceList,
  resultResourceList,
  ResultTemplateNameList,
  resultTemplateNameList,
  getTagTreeOptions,
  updateInterceptStatus,
  getOfflineLogImportInfo,
  deleteOfflineLogImportRecord,
  getAttackDefenseRanking,
  getAttachmentTypeRanking,
  getRiskLevelDistribution,
  getResourceLevelsRanking,
  getTemplateLoseEfficacyRanking,
  getVerifyDistribution,
  getDeviceProtectionList,
  getTaskScore,
  getExecuteInfo,
  getSubTaskFilterData,
  uploadMailLog,
  getAPTList,
  getAttckCascaderData,
} from '@/api/email-task-detail'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { t } from '@/i18n'

// 任务信息
export const useGetResultInfo = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest((datas: GetResultInfo) => getResultInfo(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取任务信息失败'))
    },
  })
  return [data?.data || [], run, loading] as const
}
// 进度信息
export const useResultProgressList = () => {
  const { data, runAsync: run } = useRequest(
    (datas: ResultProgressList) => resultProgressList(datas),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || t('获取进度信息失败'))
      },
    },
  )
  return [data?.data || [], run] as const
}
// 进度信息日志
export const useResultProgressDetail = () => {
  const { data, runAsync: run } = useRequest(
    (datas: ResultProgressDetail) => resultProgressDetail(datas),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || t('获取进度信息日志失败'))
      },
    },
  )
  return [data?.data || [], run] as const
}
// 任务摘要
export const useResultDetail = () => {
  const { data, runAsync: run } = useRequest((datas: ResultDetail) => resultDetail(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取任务摘要失败'))
    },
  })
  return [data?.data || [], run] as const
}
// 模板名称列表
export const useResultTemplateNameList = () => {
  const { data, runAsync: run } = useRequest(
    (datas: ResultTemplateNameList) => resultTemplateNameList(datas),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || t('获取模板名称列表失败'))
      },
    },
  )
  return [data?.data?.items || [], run] as const
}
// 附件/URL列表
interface ResultResourceListProps {
  resultResourceListParams: ResultResourceList
}
export const useResultResourceList = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest(params => resultResourceList(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取附件/URL列表失败'))
    },
  })
  return [data?.data || {}, run, loading] as const
  // return [data?.data || {}, run] as const
}
// 资源详情
export const useResultResourceDetail = () => {
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest((datas: ResultResourceDetail) => resultResourceDetail(datas), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取资源详情失败'))
    },
  })
  return [data?.data || [], run, loading] as const
}
// 邮件详情
export const useResultResourceEmailDetail = () => {
  const { data, runAsync: run } = useRequest(
    (datas: ResultResourceEmailDetail) => resultResourceEmailDetail(datas),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || t('获取邮件详情失败'))
      },
    },
  )
  return [data?.data || [], run] as const
}

//url/附件列表attck
export const useGetDetailAttCkList = () => {
  const { runAsync: run, data } = useRequest(
    (params: DetailAttCkList) => getDetailAttCkList(params),
    {
      manual: true,
      onError: (err: any) => {
        Message.error(err?.msg || t('ATT&CK列表获取失败'))
      },
    },
  )
  return [run, data?.data?.items || []] as const
}

// 攻击排名
export const useResultDefenseRankings = () => {
  const { data, runAsync: run } = useRequest(
    (datas: ResultDefenseRankings) => resultDefenseRankings(datas),
    {
      manual: true,
      onError: (err: any) => {
        message.error(err?.msg || t('获取攻击防护排名失败'))
      },
    },
  )
  return [data?.data?.attack_rate || [], run] as const
}

export const useGetFailPluginLog = () => {
  const { data, runAsync: run } = useRequest(params => getFailPluginLog(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取发送失败插件获取失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取攻击类型列表
export const useGetAttackTypeList = () => {
  const { data, runAsync: run } = useRequest(() => getAttackTypeList(), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取攻击类型列表失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}

export const useGetTagTreeOptions = () => {
  const { runAsync: run, data } = useRequest(params => getTagTreeOptions(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取标签列表失败'))
    },
  })
  return [run, data?.data?.categoryList || []] as const
}

// 更新资源拦截状态
export const useUpdateResourceInterceptStatus = () => {
  const { runAsync: run, loading } = useRequest(params => updateInterceptStatus(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('更新资源拦截状态失败'))
    },
  })

  return [run, loading] as const
}

// 2.0.2
// 获取离线日志导入信息
export const useGetOfflineLogImportInfo = () => {
  const { runAsync: run, data } = useRequest(params => getOfflineLogImportInfo(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('获取离线日志导入信息失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 删除日志设备导入记录
export const useDeleteOfflineLogImportInfo = () => {
  const { runAsync: run, loading } = useRequest(params => deleteOfflineLogImportRecord(params), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('删除日志设备导入记录失败'))
    },
  })

  return [run, loading] as const
}

// 攻击防护排名
export const useGetAttackDefenseRanking = () => {
  const { runAsync: run, data } = useRequest(params => getAttackDefenseRanking(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取攻击防护排名失败'))
    },
  })

  return [run, data?.data?.attackRate || []] as const
}

// 附件类型排名
export const useGetAttachmentTypeRanking = () => {
  const { runAsync: run, data } = useRequest(params => getAttachmentTypeRanking(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取附件类型排名失败'))
    },
  })

  return [run, data?.data?.attachmentRate || []] as const
}

// 危险等级分布
export const useGetRiskLevelDistribution = () => {
  const { runAsync: run, data } = useRequest(params => getRiskLevelDistribution(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取危险等级分布失败'))
    },
  })

  return [run, data?.data?.info || []] as const
}

// 用例等级分布
export const useGetResourceLevelsRanking = () => {
  const { runAsync: run, data } = useRequest(params => getResourceLevelsRanking(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例等级分布失败'))
    },
  })

  return [run, data?.data?.info || []] as const
}

// 模板防护失效率排名
export const useGetTemplateLoseEfficacyRanking = () => {
  const { runAsync: run, data } = useRequest(params => getTemplateLoseEfficacyRanking(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取模板防护失效率排名失败'))
    },
  })

  return [run, data?.data?.info || []] as const
}

// 验证结果分布
export const useGetVerifyDistribution = () => {
  const { runAsync: run, data } = useRequest(params => getVerifyDistribution(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取验证结果分布失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 设备防护列表
export const useGetDeviceProtectionList = () => {
  const { runAsync: run, data } = useRequest(params => getDeviceProtectionList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取设备防护列表失败'))
    },
  })

  return [run, data?.data?.devices || []] as const
}

// 任务评分
export const useGetTaskScore = () => {
  const { runAsync: run, data } = useRequest(params => getTaskScore(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取任务评分失败'))
    },
  })

  return [run, data?.data?.score || 0] as const
}

// 执行信息
export const useGetExecuteInfo = () => {
  const { runAsync: run, data } = useRequest(params => getExecuteInfo(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取执行信息失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 子任务过滤数据
export const useGetSubTaskFilterData = () => {
  const { runAsync: run, data } = useRequest(params => getSubTaskFilterData(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取子任务过滤数据失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 离线日志导入
export const useUploadMailLog = () => {
  const { runAsync: run, data } = useRequest(params => uploadMailLog(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('离线日志导入失败'))
    },
  })

  return [run, data?.data || {}] as const
}

// 获取攻击组织
export const useGetAPTList = () => {
  const { runAsync: run, data } = useRequest(params => getAPTList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取攻击组织失败'))
    },
  })
  return [run, data?.data?.aptNames || []] as const
}

// 获取attck级联数据
export const useGetAttckCascaderData = () => {
  const { runAsync: run, data } = useRequest(params => getAttckCascaderData(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取attck级联数据失败'))
    },
  })
  return [run, data?.data?.tactics || []] as const
}
